import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/typeContact'

export const typeContactService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    getPagedList,
};

//index
function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

//getAll
function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

//search
function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'GET')
}

//show
function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

//save
function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

//update
function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

//delete
function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}